import GrammarCard from './GrammarCard'

export default GrammarCard
